export const SHOW_CACHE_FLAG = 'SHOW_CACHE_FLAG';
export const HIDE_CACHE_FLAG = 'HIDE_CACHE_FLAG';

export const showCacheFlag = () => {
  return {
    type: SHOW_CACHE_FLAG
  };
};

export const hideCacheFlag = () => {
  return {
    type: HIDE_CACHE_FLAG
  };
};



// WEBPACK FOOTER //
// ./src/action/cacheFlag.js